module.exports = __webpack_public_path__ + "img/cert2.aa3378aa.png";